{
  "serviceCatalogUk": [
    {
      "element": "#service-catalog-1",
      "intro": "Вітаємо! Ви можете створити запит в IT підрозділ одним із запропонованих варіантів"
    },
    {
      "element": "#service-catalog-2",
      "intro": "Швидкий пошук потрібної вам послуги. Швидке вирішення простих інцидентів відповідними рішеннями в базі знань. База знань - вкладка на панелі роздiл навчання"
    },
    {
      "element": "#service-catalog-3",
      "intro": "Перейдіть на Каталог послуг. Щоб переглянути список доступних категорій послуг, виберіть потрібний вам сервіс та послуги, щоб переглянути наявні в ній шаблони.\nОберіть потрібний шаблон, щоб відкрити форму створення нового запиту"
    },
    {
      "element": "#info-panel-step-1",
      "intro": "Клацніть піктограму, щоб переглянути інформацію про існуючі проблеми в роботі IT сервісів. Найновіші сповіщення відображуються вгорі списку"
    },
    {
      "element": "#info-panel-step-2",
      "intro": "На вкладці 'Заявки' представлені всі ваші поточні заявки та інциденти. Усі відкриті запити та інциденти відображуються в списку >> 'Заявки' Клацніть на Тему будь-якого запиту, щоб переглянути його деталі, також ви можете виконати пошук заявки за номером або за датою створення"
    },
    {
      "element": "#info-panel-step-3",
      "intro": "Створення нового звернення до команди IT підрозділу, коли потрібна IT підтримка або послуга, така як встановлення програмного забезпечення або надання повноважень в інформаційній системі"
    }
  ]
}
